import { MprcStackPageProvider, useStackView } from "components/MprcStackView";
import { useEffect, useState } from "react";

export const Page1 = () => {
    const [count, setCount] = useState<number>(0);
    return <div>
        <h1>Página 1</h1>
        <div onClick={() => setCount(state => state + 1)}>Contador: {count}</div>
    </div>;
};


export const Page2 = () => {
    const [count, setCount] = useState<number>(0);
    return <div>
        <h1>Página 2</h1>
        <div onClick={() => setCount(state => state + 1)}>Contador: {count}</div>
    </div>;
};

const MainPage = () => {
    const sp = useStackView();

    useEffect(() => { sp.addPage(<Page1 />); }, []);

    return <div>
        <div>
            <h1>Página Principal</h1>

            {sp.count > 0 &&
                <div onClick={() => sp.backPage()}>
                    Voltar
                </div>
            }
        </div>

        {sp.renderPages()}

        <br />

        <div onClick={() => sp.addPage(<Page2 />)}>
            Ir para Página 2
        </div>
    </div>;
};

export const TestPage = () => {
    return <MprcStackPageProvider>
        <MainPage />
    </MprcStackPageProvider>;
};
